import { useContext, useState } from "react";
import { LoaderCard } from "../../common/Loader";
import { getPercentage, getProportionalSeat, translate, translateNumber, translatePercentage } from "../../../helper";
import { ASSET_HOST_BASE_URL, combinedParties, combinedParties2, combinedParties3, otherParty, PROPORTIONAL_SEAT, toBeExcludedParties } from "../../../config";
import LangContext from "../../../contexts/LangContext";

import "./index.css";

const AllParty = (props) => {
  const { fetched, result } = props;
  const { lang } = useContext(LangContext);
  let [provinceTab, setProvinceTab] = useState(1);

  const rtype = props.tab ? props.tab : "federal";
  if (rtype === "federal") {
    provinceTab = 0;
  }

  let prData = Object.keys(result).length > 0 ? result[rtype] : [];

  const handleProvinceTabClick = (el) => {
    let province = "1";
    if (el.target.tagName === "LI") {
      province = el.target.parentElement.getAttribute("datavalue");
    } else {
      province = el.target.getAttribute("datavalue");
    }
    setProvinceTab(parseInt(province));
  };

  return (
    <section className="sh-global-prop-section">
      <div className="container">
        <div className="container-fluid card sh-card-summary">
          <div className="row">
            <div className="col-md-12">
              <h1 className="text-center">{translate("proportional", lang) + " " + translate("vote", lang) + " " + translate("result", lang)}</h1>
              <br />
            </div>
          </div>
          {rtype === "provincial" && (
            <nav className="sh-prov-nav-tab-section">
              <div className="nav nav-tabs d-flex justify-content-center" id="nav-tab" role="tablist">
                {props.provinces.map((prov, i) => {
                  return (
                    <button key={i} onClick={handleProvinceTabClick} datavalue={prov.id} className={prov.id === provinceTab ? "nav-link active" : "nav-link"} data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">
                      <li>{prov["name_" + lang]}</li>
                    </button>
                  );
                })}
              </div>
              <br />
            </nav>
          )}
          {!fetched ? (
            <>
              <div className="mt-5"></div>
              <div className="mt-5"></div>
              <div className="mt-5"></div>
              <div className="mt-5"></div>
              <div className="mt-5"></div>
              <div className="mt-5"></div>
              <LoaderCard />
            </>
          ) : (
            prData
              .filter((p) => p.province === 0 || p.province === provinceTab)
              .map((result, i) => {
                const maxVote = result.data[0].vote;

                const { nationalParties, grandTotal } = getProportionalSeat(result.data, provinceTab);

                const pr_results = JSON.parse(
                  JSON.stringify(
                    result.data
                      .map((pr) => {
                        if (toBeExcludedParties.includes(pr.party)) {
                          pr.vote = -1;
                        }
                        return pr;
                      })
                      .filter((d) => d.vote > 0 || d.vote === -1)
                  )
                );

                let pc = 0;
                let dc = 0;

                return (
                  <div className="row" key={i} style={{ opacity: fetched ? "1" : 0.5 }}>
                    <div className="col-sm-12 sh-pl-20">
                      <div className="container-fluid card sh-pr-card">
                        <br />
                        <table className="table-striped mb-3" width="100%">
                          <thead>
                            <tr>
                              <th className="pd-10">{translate("sn", lang)}</th>
                              <th>{translate("party", lang)}</th>
                              <th> </th>
                              <th className="sh-right">{translate("seat", lang)}</th>
                              <th className="sh-right pd-10">{translate("vote", lang)}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pr_results.map((d, j) => {
                              const party = props.parties.find((par) => par.code === d.party) || otherParty;
                              const nationalParty = nationalParties.find((np) => np.party === d.party);

                              if (combinedParties.includes(party.code) || combinedParties2.includes(party.code) || combinedParties3.includes(party.code)) {
                                if (dc === 0) {
                                  dc = pc + 1;
                                }
                                pc = dc;
                              } else {
                                pc = pc + 1;
                                dc = 0;
                              }

                              return (
                                <tr key={j} style={combinedParties.includes(party.code) ? { background: "#d3cccc" } : combinedParties2.includes(party.code) ? { background: "#dea8a8" } : combinedParties3.includes(party.code) ? { background: "#f4b3b3" } : {}}>
                                  <td>
                                    <div className="pd-10">{translateNumber(pc, lang)}</div>
                                  </td>
                                  <td>
                                    <div>
                                      <label>
                                        <img
                                          src={ASSET_HOST_BASE_URL + "/images/parties/" + party.code.toUpperCase() + ".png"}
                                          alt={party.code.toUpperCase()}
                                          onError={({ currentTarget }) => {
                                            currentTarget.onerror = null; // prevents looping
                                            currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                                          }}
                                          className="pull-left sh-party-symbol"
                                          width="20px"
                                          height="20px"
                                        />
                                        {party["name_" + lang]}
                                      </label>
                                    </div>
                                  </td>
                                  <td width={"40%"}>
                                    {d.vote > 0 && (
                                      <div className="progress mb-0">
                                        <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: getPercentage(d.vote, maxVote), backgroundColor: party.color, opacity: 1 }}>
                                          {translatePercentage(d.vote, grandTotal, lang)}
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                  <td width={"10%"}>
                                    <div className="sh-right">{nationalParty ? translateNumber(nationalParty.seat, lang) : "-"}</div>
                                  </td>
                                  <td width={"13%"}>
                                    <div className="sh-right pd-10">
                                      <span>{d.vote === -1 ? "-" : translateNumber(d.vote, lang)}</span>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                            <tr>
                              <td>
                                <div className="pd-10">
                                  <label>
                                    <b>{translate("total", lang)}</b>
                                  </label>
                                </div>
                              </td>
                              <td></td>
                              <td width={"40%"}>
                                <div>
                                  <label className="sh-progress-bar-label" htmlFor=""></label>
                                  {/* <div className="progress">
                                    <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: getPercentage(0, 1), backgroundColor: "#00ff00", opacity: 1 }}></div>
                                  </div> */}
                                </div>
                              </td>
                              <td width={"10%"}>
                                <b>
                                  <span className="pull-right data">{translateNumber(PROPORTIONAL_SEAT[provinceTab], lang)}</span>
                                </b>
                              </td>
                              <td width={"13%"}>
                                <b>
                                  <span className="pull-right pd-10 data">{translateNumber(grandTotal, lang)}</span>
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                );
              })
          )}
        </div>
      </div>
    </section>
  );
};

export default AllParty;
